// Base components
export { BaseWidget, StatWidget } from './BaseWidget'

// Financial widgets
export {
  TotalRevenueWidget,
  OutstandingWidget,
  TotalClientsWidget,
  TotalInvoicesWidget,
  RevenueVsExpensesWidget,
  InvoiceStatusWidget,
  ExpensesOverviewWidget,
} from './FinancialWidgets'

// List widgets
export {
  RecentInvoicesWidget,
  RecentClientsWidget,
  RecentExpensesWidget,
} from './ListWidgets'

// Contract widgets
export {
  ContractStatsWidget,
  RecentContractsWidget,
  ContractsByStatusWidget,
  ContractsExpiringSoonWidget,
} from './ContractWidgets'

// Time tracking widgets
export {
  TimeTrackingStatsWidget,
  ActiveTimerWidget,
  WeeklyTimeChartWidget,
  RecentTimeEntriesWidget,
} from './TimeTrackingWidgets'

// Project widgets
export {
  ProjectStatsWidget,
  RecentProjectsWidget,
  MyTasksWidget,
  UpcomingDeadlinesWidget,
} from './ProjectWidgets'

// Notification widgets
export {
  NotificationsWidget,
  UnreadNotificationsWidget,
} from './NotificationWidgets'

// Social media widgets
export {
  SocialMediaStatsWidget,
  ScheduledPostsWidget,
  PendingApprovalWidget,
} from './SocialMediaWidgets'

// Agency KPI widgets
export {
  CashCollectedWidget,
  ProfitWidget,
  RunwayWidget,
  ActiveRevenueClientsWidget,
  ProjectsAtRiskWidget,
  UtilizationRateWidget,
  TimeLoggedWeekWidget,
  UpcomingInvoicesWidget,
} from './AgencyKPIWidgets'

// Widget type to component mapping
import type { WidgetType } from '@/types'
import { ComponentType } from 'react'

import {
  TotalRevenueWidget,
  OutstandingWidget,
  TotalClientsWidget,
  TotalInvoicesWidget,
  RevenueVsExpensesWidget,
  InvoiceStatusWidget,
  ExpensesOverviewWidget,
} from './FinancialWidgets'

import {
  RecentInvoicesWidget,
  RecentClientsWidget,
  RecentExpensesWidget,
} from './ListWidgets'

import {
  ContractStatsWidget,
  RecentContractsWidget,
  ContractsByStatusWidget,
  ContractsExpiringSoonWidget,
} from './ContractWidgets'

import {
  TimeTrackingStatsWidget,
  ActiveTimerWidget,
  WeeklyTimeChartWidget,
  RecentTimeEntriesWidget,
} from './TimeTrackingWidgets'

import {
  ProjectStatsWidget,
  RecentProjectsWidget,
  MyTasksWidget,
  UpcomingDeadlinesWidget,
} from './ProjectWidgets'

import {
  NotificationsWidget,
  UnreadNotificationsWidget,
} from './NotificationWidgets'

import {
  SocialMediaStatsWidget,
  ScheduledPostsWidget,
  PendingApprovalWidget,
} from './SocialMediaWidgets'

import {
  CashCollectedWidget,
  ProfitWidget,
  RunwayWidget,
  ActiveRevenueClientsWidget,
  ProjectsAtRiskWidget,
  UtilizationRateWidget,
  TimeLoggedWeekWidget,
  UpcomingInvoicesWidget,
} from './AgencyKPIWidgets'

export const WIDGET_COMPONENTS: Record<WidgetType, ComponentType> = {
  // Financial
  TOTAL_REVENUE: TotalRevenueWidget,
  OUTSTANDING: OutstandingWidget,
  TOTAL_CLIENTS: TotalClientsWidget,
  TOTAL_INVOICES: TotalInvoicesWidget,
  REVENUE_VS_EXPENSES: RevenueVsExpensesWidget,
  INVOICE_STATUS: InvoiceStatusWidget,
  EXPENSES_OVERVIEW: ExpensesOverviewWidget,
  RECENT_INVOICES: RecentInvoicesWidget,
  RECENT_CLIENTS: RecentClientsWidget,
  RECENT_EXPENSES: RecentExpensesWidget,
  // Contracts
  CONTRACT_STATS: ContractStatsWidget,
  RECENT_CONTRACTS: RecentContractsWidget,
  CONTRACTS_BY_STATUS: ContractsByStatusWidget,
  CONTRACTS_EXPIRING_SOON: ContractsExpiringSoonWidget,
  // Time Tracking
  TIME_TRACKING_STATS: TimeTrackingStatsWidget,
  ACTIVE_TIMER: ActiveTimerWidget,
  WEEKLY_TIME_CHART: WeeklyTimeChartWidget,
  RECENT_TIME_ENTRIES: RecentTimeEntriesWidget,
  // Projects
  PROJECT_STATS: ProjectStatsWidget,
  RECENT_PROJECTS: RecentProjectsWidget,
  MY_TASKS: MyTasksWidget,
  UPCOMING_DEADLINES: UpcomingDeadlinesWidget,
  // Notifications
  NOTIFICATIONS: NotificationsWidget,
  UNREAD_NOTIFICATIONS: UnreadNotificationsWidget,
  // Social Media
  SOCIAL_MEDIA_STATS: SocialMediaStatsWidget,
  SCHEDULED_POSTS: ScheduledPostsWidget,
  PENDING_APPROVAL: PendingApprovalWidget,
  // Agency KPI
  CASH_COLLECTED: CashCollectedWidget,
  PROFIT: ProfitWidget,
  RUNWAY: RunwayWidget,
  ACTIVE_REVENUE_CLIENTS: ActiveRevenueClientsWidget,
  PROJECTS_AT_RISK: ProjectsAtRiskWidget,
  UTILIZATION_RATE: UtilizationRateWidget,
  TIME_LOGGED_WEEK: TimeLoggedWeekWidget,
  UPCOMING_INVOICES: UpcomingInvoicesWidget,
}

